import { UsersLogsModule } from './users-logs/users-logs.module';
import { UsersLogsComponent } from './users-logs/users-logs.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// import { MainComponent } from './main/main.component';
// import { AnimalsComponent } from './animals/animals.component';
// import { WorksPendingComponent } from './works-pending/works-pending.component';
// import { PartesComponent } from './partes/partes.component';
// import { CeaComponent } from './cea/cea.component';
// import { LoginComponent } from './login/login.component';
// import { LoginRecoverComponent } from './login/login-recover.component';
import { AuthGuard } from './_guards/auth.guard';
// import { HistLactacionesComponent } from './hist-lactaciones/hist-lactaciones.component';
// import { LibrosComponent } from './libros/libros.component';
// import { InformesComponent } from './informes/informes.component';
// import { ImportsComponent } from './imports/imports.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/dashboard',
    pathMatch: 'full',
    canLoad: [AuthGuard]
  },
  {
    path: 'main',
    loadChildren: () => import('app/dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('app/dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'animals',
    loadChildren: () => import('app/animals/animals.module').then(m => m.AnimalsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'ganaderias',
    loadChildren: () => import('app/ganaderias/ganaderias.module').then(m => m.GanaderiasModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'socios',
    loadChildren: () => import('app/ganaderias/ganaderias.module').then(m => m.GanaderiasModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'socios/:id',
    loadChildren: () => import('app/socio/socio.module').then(m => m.SocioModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'ganaderias/:id',
    loadChildren: () => import('app/ganaderia/ganaderia.module').then(m => m.GanaderiaModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'cooperativas/:id',
    loadChildren: () => import('app/cooperativa/cooperativa.module').then(m => m.CooperativaModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'cea/:cea/partes',
    loadChildren: () => import('app/partes-cea/partes-cea.module').then(m => m.PartesCEAModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'cea/:cea',
    loadChildren: () => import('app/cea/cea.module').then(m => m.CeaModule),
    canLoad: [AuthGuard] },
  // {
  //   path: 'cea/:cea',
  //   loadChildren: () => import('app/dashboard/dashboard-cea.module').then(m => m.DashboardCEAModule),
  //   canLoad: [AuthGuard] },
  {
    path: 'inseminaciones',
    loadChildren: () => import('app/inseminaciones-leche/inseminaciones-leche.module').then(m => m.InseminacionesLecheModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'lactaciones',
    loadChildren: () => import('app/hist-lactaciones/hist-lactaciones.module').then(m => m.HistLactacionesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'libros',
    loadChildren: () => import('app/libros/libros.module').then(m => m.LibrosModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'pending',
    loadChildren: () => import('app/works-pending/works-pending.module').then(m => m.WorksPendingModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'partes',
    loadChildren: () => import('app/partes/partes.module').then(m => m.PartesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'recensos/:cea/:workType/:workDate',
    loadChildren: () => import('app/recensos/recensos.module').then(m => m.RecensosModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'informes',
    loadChildren: () => import('app/informes/informes.module').then(m => m.InformesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'informes-labs',
    loadChildren: () => import('app/informes-labs/informes-labs.module').then(m => m.InformesLabsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'imports',
    loadChildren: () => import('app/imports/imports.module').then(m => m.ImportsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'scales',
    loadChildren: () => import('app/scales/scales.module').then(m => m.ScalesModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'docs',
    loadChildren: () => import('app/docs/docs.module').then(m => m.DocsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'crias',
    loadChildren: () => import('app/crias/crias.module').then(m => m.CriasModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'valoracion-genetica',
    loadChildren: () => import('app/valoracion-genetica/valoracion-genetica.module').then(m => m.ValoracionGeneticaModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'users-logs',
    loadChildren: () => import('app/users-logs/users-logs.module').then(m => m.UsersLogsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'migrations',
    loadChildren: () => import('app/migrations/migrations.module').then(m => m.MigrationsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('app/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'login/recover',
    loadChildren: () => import('app/login/login-recover.module').then(m => m.LoginRecoverModule)
  },
  {
    path: 'no-siras',
    loadChildren: () => import('app/no-siras/no-siras.module').then(m => m.NoSirasModule)
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
    imports: [ RouterModule.forRoot(routes, {}) ],
    exports: [ RouterModule ]
})

export class AppRoutingModule {}
